@if (isLoading()) {
  <aux-table-skeleton />
} @else {
  <div class="flex flex-col">
    <ag-grid-angular
      id="patientBudgetEntryGrid"
      class="ag-theme-aux relative tabular-nums"
      [domLayout]="domLayout"
      [style.height]="domLayout === 'normal' ? tableHeightInEditMode() : ''"
      [gridOptions]="gridOptions()"
      [enableFillHandle]="editMode()"
      [rowData]="gridData()"
      [rowDragManaged]="true"
      (gridReady)="onGridReady($event)"
      (cellValueChanged)="cellValueChanged($event)"
      (gridSizeChanged)="gridSizeChanged()"
      (cellEditingStopped)="onCellEditingStopped($event)"
      (cellValueChanged)="onCellValueChanged($event)"
      auxStickyGrid
    />
    <p class="text-right" [class.mt-3]="!editMode()">Total: {{ totalItems() }}</p>
  </div>
}
